import React from "react";
import Modal from "./ergo-elements/components/Modal";
import I18n, { hasTranslation } from "../i18n";
import { Title } from "./PatientPathHeader";

import { getCurrentLanguage } from "../LanguageHelper";
import { useParams } from "react-router-dom";

const getLastCorrelationId = () => {
  if (window.__DKVGLOBAL && window.__DKVGLOBAL.NETWORK_TRAFFIC.length > 0) {
    return window.__DKVGLOBAL.NETWORK_TRAFFIC[0].request.headers[
      "X-Correlation-ID"
    ];
  }
  return "No X-Correlation-ID found";
};

const components = {
  ApiError: ({ path, method, body }) => {
    const { lang } = useParams();
    return (
      <>
        <Title>
          <I18n keys={["Modal Error Title", path]} />
        </Title>
        {[body].map((item) =>
          hasTranslation(getCurrentLanguage({ params: { lang } }))([
            "CODES",
            path,
            method,
            item.code,
          ]) ? (
            <I18n
              key={item.code}
              style={{ whiteSpace: "pre-line" }}
              keys={["CODES", path, method, item.code]}
            />
          ) : (
            item.userMessage
          )
        )}
      </>
    );
  },
  Timeout: ({ timeoutInMiliseconds }) => (
    <>
      <Title>
        <I18n keys={["Timeout", "Title"]} args={{ timeoutInMiliseconds }} />
      </Title>
      <I18n keys={["Timeout", "Message"]} />
    </>
  ),
  I18nedError: ({ keys }) => <I18n keys={keys} />,
};

const Notification = ({ error, dismiss, open }) => {
  console.log(error);
  const ComponentName = components[error.type];
  return (
    <Modal open={open} dismissible onDismiss={dismiss} backdropDismissesModal>
      <div style={{ padding: "0 40px 40px 40px" }}>
        {ComponentName ? (
          <ComponentName {...error} />
        ) : (
          <div>
            <Title>{error.toString()}</Title>
            {error.stack.toString()}
          </div>
        )}
        <div
          style={{ marginTop: "20px", fontSize: "smaller", color: "#9E968D" }}
        >
          {getLastCorrelationId()}
        </div>
      </div>
    </Modal>
  );
};

export default Notification;
